import { BaseApiClient } from "./base_api";
import xmlJS from "xml-js";

class ApiClient extends BaseApiClient {
  getLgpdFilesPreSignedUrl(data) {
    return this.call("files/pre-signed-url", "GET", data);
  }

  postSaveCommunicationHistory(data) {
    return this.call("/lgpd-titular/communication-history", "POST", data);
  }

  postFilesPreSignedUrl(data) {
    return this.call("files/pre-signed-url", "POST", data);
  }
}

const appApi = new ApiClient();

export default appApi;
